// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PK_cp-TheTextSkeleton-module_font_captionRegular_1{width:100%;height:1rem;border-radius:var(--border-radius-full)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"font_captionRegular_1": "PK_cp-TheTextSkeleton-module_font_captionRegular_1"
};
export default ___CSS_LOADER_EXPORT___;
